import { render } from "./TermsAndConditions.vue?vue&type=template&id=3fcab2ba&scoped=true"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js"

import "./TermsAndConditions.vue?vue&type=style&index=0&id=3fcab2ba&lang=scss"
import "./TermsAndConditions.vue?vue&type=style&index=1&id=3fcab2ba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcab2ba"]])

export default __exports__